module.exports = __webpack_public_path__ + "static/media/marco.b402423e.png";